import React from 'react';
import Alert from '../Alert';
import { useMobile } from '../Mobile';

const UninstalledUpdatePrompt = () => {
    const {downloadingUpdate, updateAvailable, installUpdate} = useMobile();

    if (!updateAvailable && !downloadingUpdate) {
        return null;
    }

    if (downloadingUpdate) {
        return (
            <Alert
                theme="brand"
                icon="PartyHorn"
                title="Updating..."
                message="Downloading the latest version of getSoapy, just a moment..."
                loading={true}
            />
        );
    }

    return (
        <Alert
            theme="brand"
            icon="PartyHorn"
            title="Update available"
            message="There's a new version of getSoapy available! Tap to update."
            onClick={installUpdate}
        />
    );

}

export default UninstalledUpdatePrompt;
